import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';


import { API_LINK } from '../../constants';
import moment from 'moment';
import { turnitinDoSubmissionFailure, turnitinDoSubmissionRequest, turnitinDoSubmissionSuccess, turnitinLinkFailure, turnitinLinkRequest, turnitinLinkSuccess } from '../reducers/turnitin';

const API = `${API_LINK}api`;



function* turnitinLinkFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { status, row } = state.markerReducer;
  const { statementid } = state.turnitinReducer;
  const {
    user,
    token,
  } = state.loginReducer;

  var names = row.thisRow.name.split(' ')

  const response = yield call(() =>
    axios({
      method: 'put',
      url: API+'/assessor/tii_ReportReport',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Uploaaded-With': 'XMLHttpUploaad',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        statementid: statementid,
      },
    }),
  );

  return response;
}

function* workerTurnitinLinkSaga() {
  try {
    const response = yield call(turnitinLinkFunctionAxios);
    const responseFromTurnitinLink = response.data;

    if (response.status === 200) {
    
        yield put(turnitinLinkSuccess(responseFromTurnitinLink));
    
    
    }
    if (response.status === 201) {
      yield put(turnitinLinkFailure(responseFromTurnitinLink.message));
    }
  } catch (error) {
    yield put(turnitinLinkFailure(error.message));
  }
}

export function* watcherTurnitinLinkSaga() {
 
  yield takeLatest(turnitinLinkRequest().type, workerTurnitinLinkSaga);
}
